module.exports = __webpack_public_path__ + "static/media/bg-pricing.19d7d877.jpeg";